module.exports = __webpack_public_path__ + "media/bootstrap-icons/safe-9b0b323a.svg";